<template>
  <main class="w-100 margin-t-large pb-0" id="CourseComponent" role="main">
    <article class="container">
      <div class="d-table bg-white mx-auto fit-width d-table mx-auto px-3 mt-1 mb-2">
        <h2 class="font-heading-1 font-semiblack font-family-concended font-all-upper">Begin here</h2>
        <div class="underlined darkgreen extend-border"></div>
      </div>
      <h3 class="my-4 font-semiblack text-center font-16-24 mb-small">Starbucks Coffee Academy</h3>
      <div class="canada-learner col-lg-6 col-md-9 col-sm-9 col-10"><p class="text-center">Canada learners: to register for Starbucks Coffee Academy, go to <a href="//canada.starbuckscoffeeacademy.com" class="link-click">Canada.StarbucksCoffeeAcademy.com</a>.</p></div>
      <section class="CourseListing my-4">
        <div class="p-4">
          <div class="row border-darkgreen">
            <div class="col-lg-6 bg-image p-0">
              <div class="image-container">
                <img :src="courses[0].media.course_image.uri" :alt="courses[0].name" srcset class="img-responsive h-100 w-100">
                <div class="overlay"></div>
              </div>
              <i class="fas fa-check font-checkmark-bg"></i>
            </div>
            <div class="col-lg-6 p-5">
              <span class="bg-orange font-white font-all-upper small px-2 py-1 position-fix">{{courses[0].org}}</span>
              <h3 class="font-heading-3 font-family-bold font-bold mt-2">{{courses[0].name}}</h3>
              <p class="font-paragraph-1">{{courses[0].short_description}}</p>
              <!-- <p class="small-text font-bold">
                NOTE: The Foundational Course is a prerequisite course and it will
                automatically be included when you register.
              </p> -->
              <button type="button" class="btn outline-button-orange active-button">Selected</button>
            </div>
          </div>
        </div>
        <div class="p-4">
          <div class="row border-darkgreen">
            <div class="col-lg-6 bg-image p-0">
              <div class="image-container">
                <img :src="courses[1].media.course_image.uri" :alt="courses[1].name" srcset class="img-responsive h-100 w-100">
                <div class="overlay"></div>
              </div>
              <i class="fas fa-check font-checkmark-bg"></i>
            </div>
            <div class="col-lg-6 p-5">
              <span class="bg-orange font-white font-all-upper small px-2 py-1 position-fix">{{courses[1].org}}</span>
              <h3 class="font-heading-3 font-family-bold font-bold mt-2">{{courses[1].name}}</h3>
              <p class="font-paragraph-1">{{courses[1].short_description}}</p>
              <!-- <p class="small-text font-bold">
                NOTE: The Foundational Course is a prerequisite course and it will
                automatically be included when you register.
              </p> -->
              <button type="button" class="btn outline-button-orange active-button">Selected</button>
            </div>
          </div>
        </div>

        <div class="row">
          <template v-for="(course,i) in courses">
            <div v-if="i>1" class="col-lg-4 col-md-6">
              <a href="JavaScript:void(0)" :area-label="course.name" class="card mb-4" @click="selectCourse(course)"
                :class="{'border-darkgreen' :selectedCourse.includes(course.name) }">
                <span class="d-none">{{course.name}}</span>
                <div class="image-container">
                  <img class="card-img-top" :src="course.media.course_image.uri" :alt="course.name">
                  <div class="overlay" style="display:none"
                    :class="{'d-block':selectedCourse.includes(course.name)}"></div>
                </div>
                <i class="fas fa-check font-checkmark-bg" style="display:none"
                  :class="{'d-block':selectedCourse.includes(course.name)}"></i>
                <div class="card-body">
                  <span class="bg-orange font-white font-all-upper small px-2 py-1"
                    style="position: relative;top: -2.7rem;">{{course.org}}</span>
                  <h5 class="card-title font-family-bold">{{course.name}}</h5>
                  <!-- <h5 class="card-title font-family-bold text-dummy">{{course.name}}</h5> -->
                  <p class="card-text">{{course.short_description}}</p>
                  <a href="javascript:void(0)" class="btn outline-button-orange button-allignment"
                    :class="{'active-button': selectedCourse.includes(course.name)}">{{selectedCourse.includes(course.name) ? 'Selected' : 'Select' }}</a>
                </div>
              </a>
            </div>
          </template>
        </div>
        
      </section>
    </article>
    <transition name="fade">
      <section class="register-section position-fixed" v-if="showFixedCourses">
        <div class="fixed-register d-flex flex-wrap align-items-center container py-3">
          <div class="lhs">
              <h2 class="font-heading-2">
              <i class="fas fa-check checkmark-bg"></i>
              {{selectedCourse.length}} {{selectedCourse.length > 1 ? 'courses' : 'course'}}
              selected
            </h2>
          </div>
          <b-button class="button btn btn-primary" data-toggle="modal" data-target="#exampleModal">Register</b-button>
        </div>
      </section>
    </transition>
    <section class="register-section">
      <div class="fixed-register d-flex flex-wrap align-items-center container py-4">
        <div class="lhs">
          <h2 class="font-heading-2">
            <i class="fas fa-check checkmark-bg"></i>
            {{selectedCourse.length}} {{selectedCourse.length > 1 ? 'courses' : 'course'}}
            selected
          </h2>
        </div>
         <b-button class="button btn btn-primary" data-toggle="modal" data-target="#exampleModal">Register</b-button>
      </div>
    </section>
    </transition>
    <section class="modal-register"  v-if="showContent">
      <div data-backdrop="static" data-keyboard="false" class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-label="Registration form" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
      <register-component :selectedCourses="selectedCourse"
        :selectCourseObjs="selectCourseObj" v-if="$store.state.currentStep===0"></register-component>
      <success-component v-if="$store.state.currentStep===1"></success-component>
      </div>
    </div>
  </div>
</div>
    </section>
  </main>
</template>

<script>
  import Courses from "../assets/documents/Courses.json";
  import RegisterComponent from "./wizard/RegisterComponent.vue";
  import util from "../services/utils.js";
  import SuccessComponent from "./SuccessComponent.vue";
  const _ = require("lodash");
  export default {
    data() {
      return {
        showContent:true,
        courses: (util.getEnv() === 'prod') ? Courses.prodData : Courses.stageData,
        selectedCourse: [],
        selectCourseObj: [],
        showFixedCourses: false,
      };
    },
    mounted() {
      this.selectedCourse.push(this.courses[0].name);
      this.selectedCourse.push(this.courses[1].name);
      this.selectCourseObj.push({
        name: this.courses[0].name,
        id: this.courses[0].id
      });
      this.selectCourseObj.push({
        name: this.courses[1].name,
        id: this.courses[1].id
      });
    },
    methods: {
      getImgUrl(image) {
        return require("../assets/images/" + image);
      },
      selectCourse(course) {
        if (this.selectedCourse.includes(course.name)) {
          let index = this.selectedCourse.indexOf(course.name);
          this.selectedCourse.splice(index, 1);
          this.selectCourseObj.splice(
            _.findIndex(this.selectCourseObj, ["id", course.id]),
            1
          );
        } else {
          this.selectedCourse.push(course.name);
          this.selectCourseObj.push({
            name: course.name,
            id: course.id
          });
        }
      },
      handleScroll(event) {
        if (
          window.pageYOffset >=
          document.getElementById("CourseComponent").offsetTop && window.pageYOffset <= (document.getElementById("footer").offsetTop - ($(window).height() + $(window).height()/5)) 
        ) {
          this.showFixedCourses = true;
        } 
        else {
          this.showFixedCourses = false;
        }
      }
    },
    created() {
      window.addEventListener("scroll", this.handleScroll);
    },
    destroyed() {
      window.removeEventListener("scroll", this.handleScroll);
    },
    components: {
      RegisterComponent,
      SuccessComponent
    }
  };
</script>